import { createContext, useContext } from 'react';

export type OrganisationFilterContextValue = {
  selectedOrganisationId: string | null;
  setSelectedOrganisationId: (organisationId: string | null) => void;
};

export type ProjectFilterContextValue = {
  selectedProjectId: string | null;
  setSelectedProjectId: (projectId: string | null) => void;
};

export const OrganisationFilterContext = createContext<OrganisationFilterContextValue | undefined>(
  undefined,
);

export const ProjectFilterContext = createContext<ProjectFilterContextValue | undefined>(undefined);

export const useOrganisationFilter = (): OrganisationFilterContextValue => {
  const context = useContext(OrganisationFilterContext);
  if (!context) {
    throw new Error('useOrganisationFilter must be used within OrganisationFilterProvider');
  }
  return context;
};

export const useProjectFilter = (): ProjectFilterContextValue => {
  const context = useContext(ProjectFilterContext);
  if (!context) {
    throw new Error('useProjectFilter must be used within ProjectFilterProvider');
  }
  return context;
};
